import {
  Stack,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { closeKeyboard } from "../../../utils/closeKeyboard";

//項目テキスト回答種別１
export const AnswerItemOne = ({
  answerYesNo,
  item,
  itemAnswers,
  setItemAnswers,
}) => {
  return (
    <FormControlLabel
      disabled={!answerYesNo}
      control={
        <Checkbox
          value={item.itemNo}
          checked={
            !!itemAnswers.find(
              (i) => i.itemNo?.toString() === item.itemNo?.toString()
            )
          }
          onChange={(event) => {
            if (event.target.checked) {
              setItemAnswers([...itemAnswers, { itemNo: item.itemNo }]);
            } else {
              setItemAnswers(
                itemAnswers.filter(
                  (i) => i.itemNo.toString() !== item.itemNo.toString()
                )
              );
            }
          }}
        />
      }
      label={item.itemTitle}
    />
  );
};

//テキスト入力値取得部分を共通
const getValue = (itemAnswers = [], item) => {
  if (itemAnswers.length === 0) {
    return "";
  } else {
    return (
      itemAnswers.find((i) => i.itemNo?.toString() === item.itemNo?.toString())
        ?.itemAnswerText || ""
    );
  }
};

//項目テキスト回答種別２
export const AnswerItemTwo = ({
  answerYesNo,
  item,
  itemAnswers,
  setItemAnswers,
}) => {
  return (
    <Stack direction="row" spacing="1%" marginTop="1%">
      <Typography color={answerYesNo ? undefined : "#bdbdbd"}>
        {item.itemTitle}
      </Typography>
      <TextField
        sx={{ width: "20%" }}
        variant="standard"
        size="small"
        disabled={!answerYesNo}
        onChange={(event) => {
          if (event.target.value === "") {
            setItemAnswers(
              itemAnswers.filter(
                (i) => i.itemNo.toString() !== item.itemNo.toString()
              )
            );
          } else {
            setItemAnswers([
              ...itemAnswers.filter(
                (i) => i.itemNo.toString() !== item.itemNo.toString()
              ),
              { itemNo: item.itemNo, itemAnswerText: event.target.value },
            ]);
          }
        }}
        onKeyDown={(event) => closeKeyboard(event)}
        value={getValue(itemAnswers, item)}
      />
      <Typography color={answerYesNo ? undefined : "#bdbdbd"}>
        {item.itemTextEndText}
      </Typography>
    </Stack>
  );
};

//項目テキスト回答種別３
export const AnswerItemThree = ({
  answerYesNo,
  item,
  itemAnswers,
  setItemAnswers,
}) => {
  return (
    <Stack spacing="1%" marginTop="3%">
      <Typography color={answerYesNo ? undefined : "#bdbdbd"}>
        {item.itemTitle}
      </Typography>
      <TextField
        multiline
        rows={3}
        variant="outlined"
        size="small"
        disabled={!answerYesNo}
        onChange={(event) => {
          if (event.target.value === "") {
            setItemAnswers(
              itemAnswers.filter(
                (i) => i.itemNo.toString() !== item.itemNo.toString()
              )
            );
          } else {
            setItemAnswers([
              ...itemAnswers.filter(
                (i) => i.itemNo.toString() !== item.itemNo.toString()
              ),
              { itemNo: item.itemNo, itemAnswerText: event.target.value },
            ]);
          }
        }}
        onKeyDown={(event) => closeKeyboard(event)}
        value={getValue(itemAnswers, item)}
      />
    </Stack>
  );
};
